import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { problemRisks, problemAnswers } from '../data/problem';
import { galleryImages } from '../data/gallery';
export function ProblemSection() {
  return <section className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" data-id="element-152" data-mp="2vqhh2ecujw0x">
      <div className="mx-auto max-w-6xl" data-id="element-153" data-mp="2vp6e2gr86sav">
        <SectionHeading tone="dark" size="lg" overline="The part nobody tells you" title={<>
              It looks simple... until your flowers{' '}
              <span className="italic text-gold-200" data-id="element-155" data-mp="3jglge9j059m4">
                break, stain or lose their color
              </span>
            </>} subtitle={<>
              Pressing flowers so they stay beautiful for years takes more than
              tucking them into a heavy book. The{' '}
              <strong className="font-semibold text-cream" data-id="element-156" data-mp="1k49b7nwd8u8k">
                method, materials, timing and care
              </strong>{' '}
              are what make all the difference.
            </>} data-id="element-154" data-mp="39hctg0mk0v99" />

        <ul className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-157" data-mp="ocg7p0zf74qb">
          {problemRisks.map(risk => <li key={risk.title} className="flex h-full flex-col rounded-2xl border border-sage-700 bg-sage-900/60 p-5" data-id="element-158" data-mp="sbyszxv5lhto">
              <AlertTriangleIcon className="h-4 w-4 text-rose-400" aria-hidden="true" data-id="element-159" data-mp="122thl8vvgtia" />
              <h3 className="mt-3 font-sans text-[14px] font-semibold uppercase tracking-[0.08em] text-cream" data-id="element-160" data-mp="174itsrutzd7y">
                {risk.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-sage-200" data-id="element-161" data-mp="1g22wm58cdhko">
                {risk.body}
              </p>
            </li>)}
        </ul>

        <div className="mt-14 grid items-center gap-8 rounded-4xl bg-cream p-6 sm:p-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12" data-id="element-162" data-mp="3huh9uqzxxxur">
          <img src="https://cdn.magicpatterns.com/uploads/4M1a8xdUiCtTkQWyBqk2x4/PRESSED_FLOWERS_STUDIO_MOCKUP.png" alt="Pressed Flower Studio ebook — The Complete Guide to Flower Pressing & Botanical Crafts" className="mx-auto w-full max-w-[400px] drop-shadow-[0_30px_50px_rgba(56,52,44,0.18)]" data-id="element-163" data-mp="p1bonq0w4uq8" />
          <div data-id="element-164" data-mp="u1q0lj5m4otj">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-gold-600" data-id="element-165" data-mp="17z4r6r7lr2n3">
              What the guide solves
            </p>
            <h3 className="mt-4 font-serif text-[1.9rem] leading-[1.1] text-sage-800 sm:text-[2.3rem]" data-id="element-166" data-mp="12z8pwzqahpb8">
              The difference between a ruined flower and a{' '}
              <span className="italic text-terracotta-500" data-id="element-167" data-mp="1cpbiiyti1191">keepsake that lasts years</span>{' '}
              is the method
            </h3>
            <ul className="mt-7 space-y-3.5" data-id="element-168" data-mp="1qq5u1qbufibx">
              {problemAnswers.map(answer => <li key={answer} className="flex items-start gap-3" data-id="element-169" data-mp="1ls49f0yrrayc">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-170" data-mp="25c1qp2a9bq5g">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-171" data-mp="2aa35vc4kb5bn" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-172" data-mp="20cgrcqr6dfs7">
                    {answer}
                  </span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-gold-200 pt-5 text-[14px] italic leading-relaxed text-ink-soft" data-id="element-173" data-mp="1rca6gjt5ddj0">
              Every batch that fails costs you weeks of waiting and supplies you
              already paid for. This guide exists so that never happens — starting
              with your very first flower.
            </p>
          </div>
        </div>
      </div>
    </section>;
}